const zhTW = {
  meta: { code: "zh-TW", label: "繁體中文" },
  nav: {
    brand: "IQ Log",
    diagnostics: "測驗",
    mypage: "我的頁面",
    login: "登入",
    register: "註冊",
    logout: "登出",
  },
  hero: {
    eyebrow: "測驗平台",
    title: "透過測驗發現你的本質",
    subtitle1: "思考、性格與天賦——完全視覺化",
    subtitle2: "5 分鐘看清你的優勢與短處",
    subtitle3: "每一次測驗都成為你的資料",
    cta_primary: "開始測驗",
    cta_secondary: "瀏覽目錄",
    disclaimer: "參考資訊 / 非醫療",
  },
  categories: {
    ability: "能力",
    personality: "性格",
    mental: "心理",
    aptitude: "適性",
    traits: "特質",
  },
  catalog: {
    title: "全部測驗",
    subtitle: "17 項測驗 / 5 大類別",
    filter_all: "全部",
    duration: "分鐘",
    difficulty: { easy: "簡單", medium: "中等", hard: "困難" },
    question_count: "題",
    start: "開始",
  },
  quiz: {
    question: "題目",
    of: "/",
    next: "下一題",
    prev: "上一題",
    submit: "查看結果",
    progress: "進度",
    exit: "離開",
    required: "請選擇一個選項",
    submitting: "評分中…",
  },
  result: {
    overall: "綜合分數",
    type_label: "類型",
    share_link: "用連結分享結果",
    back_to_catalog: "進行其他測驗",
    view_mypage: "在我的頁面查看歷史",
    premium_title: "解鎖詳細分析",
    premium_subtitle: "高級版可看到以下全部內容:",
    feature_breakdown: "詳細分數拆解",
    feature_cause: "根因分析",
    feature_plan: "改進計畫",
    feature_pdf: "PDF 報告(A4)",
    price: "¥980",
    price_note: "(透過 Stripe 安全結帳)",
    price_free: "免費",
    price_free_note: "(限時 · 100% 免費)",
    unlock_button: "用 Stripe 付款",
    unlock_button_free: "免費解鎖",
    unlock_requires_auth: "請登入後解鎖",
    unlock_save_first: "請先用帳戶儲存結果",
    unlocking: "正在跳轉到 Stripe…",
    free_only_notice: "免費版僅顯示綜合分數與類型。",
    compliance_note: "本測驗僅供參考,並非醫療診斷。我們避免使用斷定性或令人焦慮的措辭。",
  },
  premium: {
    title: "詳細分析報告",
    summary: "整體摘要",
    strengths: "優勢",
    weaknesses: "成長空間",
    improvements: "改進計畫",
    dimensions: "維度分數",
    download_pdf: "下載 PDF",
    pdf_soon: "PDF 匯出(即將推出)",
  },
  mypage: {
    title: "我的頁面",
    subtitle: "你的歷史、分數趨勢與徽章",
    total: "測驗總數",
    average: "平均分數",
    premium_count: "已解鎖",
    categories_covered: "涵蓋類別",
    trend_title: "分數趨勢",
    history_title: "歷史紀錄",
    badges_title: "徽章",
    unlock_3_title: "解鎖綜合分析",
    unlock_3_desc: "再做 {n} 次測驗即可解鎖綜合分析",
    unlocked: "綜合分析已解鎖",
    no_history: "尚無測驗——立即開始第一次。",
  },
  auth: {
    login_title: "登入",
    register_title: "建立帳戶",
    email: "電子郵件",
    password: "密碼(至少 6 位)",
    name: "顯示名稱(選填)",
    login_btn: "登入",
    register_btn: "註冊",
    go_register: "沒有帳戶?註冊",
    go_login: "已有帳戶?登入",
    anon_note: "測驗免費且匿名。僅在儲存結果或解鎖高級時需要帳戶。",
    success_register: "帳戶已建立",
    success_login: "已登入",
    consent_section: "同意事項",
    consent_required: "請同意必填項",
    accept_terms_pre: "我同意",
    terms_link: "服務條款",
    accept_terms_post: "",
    accept_privacy_pre: "我已閱讀",
    privacy_link: "隱私政策",
    accept_privacy_post: ",並同意處理我的個人資料",
    accept_age: "我已滿 16 歲(或已取得監護人同意)",
    accept_marketing: "請寄送新測驗與促銷郵件給我",
    optional: "選填",
  },
  landing: {
    status_online: "系統在線",
    status_subtitle: "診斷 OS v2.0",
    status_tests: "17 項測驗",
    status_langs: "14 種語言",
    status_ai: "AI · 已啟用",
    title_line1: "透過測驗發現",
    title_line2: "你的本質。",
    trust_diagnostics: "測驗",
    trust_languages: "語言",
    trust_per_test: "每項",
    hud_readout: "主要讀數",
    hud_score_unit: "/100 綜合",
    hud_band: "等級 · GOLD",
    hud_dimensions: "維度",
    hud_dimensions_status: "3 / 3 活躍",
    hud_syslog: "系統日誌",
    cat_eyebrow: "// 類別",
    cat_title_pre: "5 大類 · ",
    cat_title_highlight: "17 項測驗",
    view_all: "查看全部",
    proto_eyebrow: "// 流程",
    proto_title_pre: "用 3 步 ",
    proto_title_highlight: "解鎖本質。",
    step1_title: "選擇測驗",
    step1_body: "從 17 種中選擇,可匿名開始。",
    step2_title: "5 分鐘作答",
    step2_body: "進度條與徽章助你前行。",
    step3_title: "AI 解鎖",
    step3_body: "詳細分數、計畫與 PDF。",
    final_eyebrow: "// 準備好了嗎?",
    final_title_pre: "你的本質 ",
    final_title_highlight: "5 分鐘見分曉。",
    final_subtitle: "5 分鐘看清你的優勢與短處",
    final_button: "立即開始測驗",
  },
  footer: {
    tagline: "記錄你的思考、性格與適性的測驗平台",
    rights: "保留所有權利。",
    legal: "法律",
    privacy: "隱私",
    terms: "條款",
    about_label: "關於 / 公司",
    compliance_label: "國際合規",
    tokushoho_label: "日本特商法表記",
    data_protection_label: "資料保護(國際版)",
    data_request_label: "資料刪除 / 退出申請",
    disclaimer_label: "免責聲明",
    disclaimer_full: "本服務僅供參考,並非醫療診斷。我們不使用斷定性或令人焦慮的措辭。",
  },
  badges: {
    "first-diagnosis": "首次測驗",
    "three-diagnostics": "3 次測驗",
    "five-diagnostics": "5 次測驗",
    "ten-diagnostics": "10 次測驗",
    "high-performer": "高分使用者",
    "premium-user": "高級使用者",
  },
  lang_selector: "語言",
  payment: {
    processing_title: "正在確認付款…",
    processing_subtitle: "已從 Stripe 返回——正在生成詳細分析(最多 20 秒)",
    success: "付款已確認——高級已解鎖",
    expired: "結帳工作階段已逾期,請重試。",
    error: "無法確認付款,請聯絡客服。",
  },
};
export default zhTW;
